<vi-page [sidenavs]="true" [footer]="true">
  <div class="container" head>
    <div class="flex flex-row justify-between items-center">
      <h1>{{ 'DEMO_SETTINGS.MANAGE_FEATURES_HEADER' | translate }}</h1>
      <div>
        <button mat-raised-button color="primary" (click)="restoreDefault()">
          {{ 'GENERAL.BUTTON.RESTORE_DEFAULT' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          gtm="onGoToPage"
          gtmAction="Feature settings close"
          gtmCategory="Demo"
          routerLink="/installations"
        >
          {{ 'GENERAL.BUTTON.CLOSE' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="container flex flex-row flex-wrap gap-[24px]" body>
    <div
      class="card-container flex flex-col gap-[8px] justify-start items-center"
      *ngFor="let deviceSerial of DeviceSerials"
    >
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <div class="flex flex-col">
              <div>
                <b>{{ deviceSerial }}</b>
              </div>
              <div>{{ DemoDeviceSerials[deviceSerial] }}</div>
            </div>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-form-field class="plan-select" mat-select-height-large>
            <mat-label>{{ '+BOOKING.TITLE.SELECT_PLAN' | translate }}</mat-label>
            <mat-select
              (selectionChange)="onPlanChanged($event, deviceSerial)"
              [value]="demoSettingsStore.selectCurrentPlan(DemoDeviceSerials[deviceSerial]) | async"
            >
              <mat-option *ngFor="let plan of SubscriptionPlans" [value]="plan">
                {{ plan }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div
            class="flex flex-row justify-between items-center"
            *ngFor="let feature of PaidFeatures"
          >
            <h5>{{ feature }}</h5>
            <mat-slide-toggle
              gtm="onToggle"
              gtmAction="Turn feature on off"
              gtmCategory="Manage features"
              [checked]="
                demoSettingsStore.selectIsFeatureEnabled(DemoDeviceSerials[deviceSerial], feature)
                  | async
              "
              (change)="featureToggleChecked($event, deviceSerial, feature)"
            >
            </mat-slide-toggle>
          </div>
        </mat-card-content>
        <mat-card-actions
          class="flex flex-row gap-[8px] justify-end items-center"
          *ngrxLet="
            demoSettingsStore.selectAreAllFeaturesEnabled(
              DemoDeviceSerials[deviceSerial]
            ) as areAllFeaturesSelected
          "
        >
          <h5>
            {{
              areAllFeaturesSelected
                ? ('GENERAL.BUTTON.DISABLE_ALL' | translate)
                : ('GENERAL.BUTTON.ENABLE_ALL' | translate)
            }}
          </h5>
          <mat-slide-toggle
            gtm="onToggle"
            gtmAction="Turn all features on or off"
            gtmCategory="Manage features"
            [checked]="areAllFeaturesSelected"
            (change)="deviceToggleChecked($event, deviceSerial)"
          >
          </mat-slide-toggle>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</vi-page>
